import { z } from 'zod';
import { eventSchema } from './envelope';

export const MEDIA_FILE_READY_V1 = 'media.file.ready.v1' as const;
export const MEDIA_FILE_REJECTED_V1 = 'media.file.rejected.v1' as const;

/**
 * Een bestand is binnen en gecontroleerd. Hier hangt straks de virusscanner aan (Fase 2):
 * die luistert op dit event en kan een bestand daarna alsnog afkeuren.
 */
export const fileReadyV1Schema = eventSchema({
  fileId: z.guid(),
  ownerModule: z.string(),
  purpose: z.string(),
  mimeType: z.string(),
  sizeBytes: z.number().int(),
});

export const fileRejectedV1Schema = eventSchema({
  fileId: z.guid(),
  ownerModule: z.string(),
  reason: z.string(),
});

export type FileReadyV1 = z.infer<typeof fileReadyV1Schema>;
export type FileRejectedV1 = z.infer<typeof fileRejectedV1Schema>;

export const mediaEventCatalog = {
  [MEDIA_FILE_READY_V1]: fileReadyV1Schema,
  [MEDIA_FILE_REJECTED_V1]: fileRejectedV1Schema,
} as const;
